import {
  Card,
  CardContent,
  Grid,
  Typography,
  Box,
  Link as MaterialUiLink
} from '@material-ui/core';
import React from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { iRootState } from '../redux/store';

const PaymentScheduleHeader = function PaymentScheduleHeader(): React.ReactElement {
  const sentDate = useSelector((state: iRootState) => state.quote.sentDate);
  const title = useSelector((state: iRootState) => state.quote.title);
  const quoteId = useSelector((state: iRootState) => state.quote.id);
  return (
    <Card elevation={1}>
      <CardContent>
        <Grid container alignItems='center'>
          <Grid item md={8} xs={12}>
            <Typography color='primary' variant='h5'>
              <Box fontWeight='bold'>
                <FormattedMessage
                  id='PaymentTerms.PaymentSchedule'
                  defaultMessage='Payment Schedule'
                />
              </Box>
            </Typography>
          </Grid>
          <Grid item md={2} xs={12}>
            <Typography color='primary' variant='subtitle1'>
              <Box fontWeight='bold'>
                <FormattedMessage id='Date' defaultMessage='Date' />
              </Box>
            </Typography>
            <Typography variant='h5'>
              <FormattedDate value={sentDate} />
            </Typography>
          </Grid>
          <Grid item md={2} xs={12}>
            <Typography color='primary' variant='subtitle1'>
              <Box fontWeight='bold'>
                <FormattedMessage
                  id='PaymentTerms.QuoteName'
                  defaultMessage='Quote Name'
                />
              </Box>
            </Typography>
            <Typography variant='h5'>
              <MaterialUiLink
                component={Link}
                to={`/quote/${quoteId}`}
                color='textSecondary'
                underline='always'
              >
                {title}
              </MaterialUiLink>
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default PaymentScheduleHeader;
